"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var effects_1 = require("@ngrx/effects");
var store_1 = require("@ngrx/store");
var skynet_store_properties_api_1 = require("@synisys/skynet-store-properties-api");
var skynet_store_utilities_1 = require("@synisys/skynet-store-utilities");
var lodash_1 = require("lodash");
var Observable_1 = require("rxjs/Observable");
var of_1 = require("rxjs/observable/of");
var operators_1 = require("rxjs/operators");
var noop_1 = require("rxjs/util/noop");
var properties_utilities_1 = require("../properties.utilities");
var property_service_1 = require("../services/property.service");
var logger = properties_utilities_1.createLogger('properties-effects');
var PropertiesEffects = /** @class */ (function () {
    function PropertiesEffects(actions$, propertyService, store) {
        var _this = this;
        this.actions$ = actions$;
        this.propertyService = propertyService;
        this.store = store;
        this.loadProperties$ = this.actions$.pipe(effects_1.ofType(skynet_store_properties_api_1.PropertiesActionTypes.GetProperties), operators_1.tap(function () { return logger.debug('received action to load properties'); }), operators_1.switchMap(function () {
            return _this.store.pipe(operators_1.map(function (state) { return state.properties.map; }), operators_1.distinctUntilChanged(function (propertyMapX, propertyMapY) {
                if (lodash_1.isNil(propertyMapY) && lodash_1.isNil(propertyMapX)) {
                    return true;
                }
                else if (lodash_1.isNil(propertyMapY) || lodash_1.isNil(propertyMapX)) {
                    return false;
                }
                else {
                    return lodash_1.isEqual(propertyMapY, propertyMapX);
                }
            }), operators_1.switchMap(function (propertyMap) {
                if (propertyMap === undefined) {
                    logger.debug('requesting property service to load properties');
                    return _this.propertyService.loadProperties().pipe(operators_1.map(function (properties) {
                        return new skynet_store_properties_api_1.GetPropertiesSuccess((properties));
                    }), operators_1.catchError(function (err, caught) {
                        return of_1.of(new skynet_store_properties_api_1.GetPropertiesError(new skynet_store_utilities_1.StoreManagerError(err, 'could not load properties')));
                    }));
                }
                else {
                    return of_1.of(new skynet_store_properties_api_1.GetPropertiesSuccess(propertyMap));
                }
            }));
        }));
        this.printError = this.actions$.pipe(effects_1.ofType(skynet_store_properties_api_1.PropertiesActionTypes.GetPropertiesError), operators_1.map(function (action) {
            if (lodash_1.get(action.payload, 'type') === 'StoreManagerError') {
                skynet_store_utilities_1.logStoreError(action.payload, logger);
            }
            else {
                logger.error('error while loading: error => \n %o', action.payload);
            }
        }), operators_1.tap(noop_1.noop, function (e) { return logger.error(e); }));
    }
    __decorate([
        effects_1.Effect(),
        __metadata("design:type", Observable_1.Observable)
    ], PropertiesEffects.prototype, "loadProperties$", void 0);
    __decorate([
        effects_1.Effect({ dispatch: false }),
        __metadata("design:type", Object)
    ], PropertiesEffects.prototype, "printError", void 0);
    PropertiesEffects = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [effects_1.Actions,
            property_service_1.PropertyService,
            store_1.Store])
    ], PropertiesEffects);
    return PropertiesEffects;
}());
exports.PropertiesEffects = PropertiesEffects;
//# sourceMappingURL=properties.effects.js.map